import { render } from "./systemGetUserData.vue?vue&type=template&id=e061bf32"
import script from "./systemGetUserData.vue?vue&type=script&lang=js"
export * from "./systemGetUserData.vue?vue&type=script&lang=js"
script.render = render

export default script